export const ON_ASSESSMENT_QUESTIONNAIRE_CHANGES =
  "ON_ASSESSMENT_QUESTIONNAIRE_CHANGES";

export const onChangeAssessmentQuestionnaire = (payload) => {
  return {
    type: ON_ASSESSMENT_QUESTIONNAIRE_CHANGES,
    payload,
  };
};
